import Swal from 'sweetalert2';

// project-imports
import "./SweetAlert.css";

export const showToast = (icon, title, animation, position, showConfirmButton, timerProgressBar, timer) => {
    var toastMixin = Swal.mixin({
        toast: true,
        icon: icon,
        text: title,
        animation: animation,
        position: position,
        showConfirmButton: showConfirmButton,
        timer: timer || 3000,
        timerProgressBar: timerProgressBar,
        showCloseButton: true,
        iconColor: 'white',
        customClass: {
            popup: 'colored-toast',
        },
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    toastMixin.fire({
        icon: icon,
        animation: animation,
        position: position,
        text: title
    });
}